import http from "../axios/http-common";

class InterfaceFormPrefill {
  /**
   * Fetch prefill payload for a form. Sources may be passed as a
   * comma-separated string (e.g. "patient_defaults,latest_encounter"); when
   * omitted, the backend uses the form's default source set.
   */
  getPrefill(
    pasienRm: string,
    formKey: string,
    params: {
      register_id?: number | string;
      unit_id?: string;
      sources?: string;
    } = {}
  ) {
    // getDataParam meneruskan argumen ke-2 sebagai axios config —
    // params WAJIB dibungkus { params } agar terkirim sebagai query string.
    return http.getDataParam(`/form-prefill/${pasienRm}/${formKey}`, {
      params
    });
  }

  logAcceptance(payload: {
    form_key: string;
    pasien_rm: string;
    register_id?: number | string | null;
    unit_id?: string | null;
    event: "accepted" | "rejected" | "partial";
    fields: string[];
    provenance?: Record<string, any>;
    sources?: string[];
  }) {
    return http.postData(`/form-prefill/log`, payload);
  }
}

export default new InterfaceFormPrefill();
